import { liquidGlassSurfaceFillSx } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { voiceCommandParamExample, voiceCommandParamLabel, type VoiceCommandDoc, type VoiceCommandParam } from '../../data/voiceCommandsDocs';

interface VoiceModalListeningHintsParamChipsProps {
  cmd: VoiceCommandDoc;
  chips: VoiceCommandParam[];
  moreCount: number;
}

export const VoiceModalListeningHintsParamChips: FC<VoiceModalListeningHintsParamChipsProps> = ({
  cmd,
  chips,
  moreCount,
}) => {
  const { t } = useTranslation();
  if (chips.length === 0 && moreCount <= 0) return null;

  return (
    <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={0.75} sx={{ pt: 1.25 }}>
      <Text
        style={{
          width: '100%',
          fontSize: 10,
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: 'var(--tg-theme-hint-color)',
          opacity: 0.7,
          textAlign: 'center',
          marginBottom: 4,
        }}
      >
        {t('voice.alsoAdd')}
      </Text>
      {chips.map((p) => (
        <Box
          key={p.id}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            px: 1.25,
            py: 0.5,
            borderRadius: 1.75,
            ...liquidGlassSurfaceFillSx,
          }}
        >
          <Text style={{ fontSize: 12, fontWeight: 700, color: 'var(--tg-theme-button-color)' }}>
            {voiceCommandParamLabel(cmd, p)}
          </Text>
          <Text
            style={{
              fontSize: 11,
              fontStyle: 'italic',
              color: 'var(--tg-theme-hint-color)',
              opacity: 0.9,
            }}
          >
            {voiceCommandParamExample(cmd, p)}
          </Text>
        </Box>
      ))}
      {moreCount > 0 && (
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            px: 1.25,
            py: 0.5,
            borderRadius: 1.75,
            ...liquidGlassSurfaceFillSx,
          }}
        >
          <Text style={{ fontSize: 12, fontWeight: 600, color: 'var(--tg-theme-text-color)' }}>
            {t('voice.more', { count: moreCount })}
          </Text>
        </Box>
      )}
    </Stack>
  );
};
